import React from 'react';
import { useNavigate } from 'react-router-dom';

function LogoButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/home');
  };

  return (
    <button onClick={handleClick} className="logo-button">
      RecipeShare
    </button>
  );
}

export default LogoButton;